<div class="slide-toggle-root" [class.big-toggle]="isBigToggle">
  <mat-slide-toggle
    (change)="onToggleChange($event)"
    [checked]="checked"
    [ngClass]="currentColorClass"
    [disableRipple]="true"
    [disabled]="disabled"
  >
  </mat-slide-toggle>
  <span [ngClass]="currentColorClass"><ng-content></ng-content></span>
</div>
